import { Toaster as Sonner, type ToasterProps } from "sonner";
import {
  FeedbackError,
  FeedbackInfo,
  FeedbackSuccess,
  FeedbackWarning,
  StatusLoading,
} from "../../icons.ts";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <FeedbackSuccess className="size-4" />,
        info: <FeedbackInfo className="size-4" />,
        warning: <FeedbackWarning className="size-4" />,
        error: <FeedbackError className="size-4" />,
        loading: <StatusLoading className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--color-popover)",
          "--normal-text": "var(--color-popover-foreground)",
          "--normal-border": "var(--color-border)",
          "--success-bg": "var(--color-success-subtle)",
          "--success-text": "var(--color-success-on)",
          "--success-border": "var(--color-success)",
          "--warning-bg": "var(--color-warning-subtle)",
          "--warning-text": "var(--color-warning-on)",
          "--warning-border": "var(--color-warning)",
          "--error-bg": "var(--color-danger-subtle)",
          "--error-text": "var(--color-danger-on)",
          "--error-border": "var(--color-danger)",
          "--info-bg": "var(--color-info-subtle)",
          "--info-text": "var(--color-info-on)",
          "--info-border": "var(--color-info)",
          "--border-radius": "var(--radius-lg)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
